import React from 'react';
import styled from '@emotion/styled';
import type { ResponsiveValue } from 'styled-system';
import { themeGet } from 'styled-system';

import { spinAnimation } from '../theme/animation';
import { Flex } from './Flex';
import type { IconProps } from './Icon';
import Icon from './Icon';

interface SpinnerProps {
  size?: ResponsiveValue<number>;
  strokeColor?: string;
  margin?: ResponsiveValue<string | number>;
  className?: string;
}

interface SpinnerIconStyleProps {
  strokeColor: string;
}

const wrapperStyles = { display: 'flex', justifyContent: 'center', alignItems: 'center' };
const fullPageWrapperStyles = { alignItems: 'center', height: '100%' };

const SpinnerIcon = styled(Icon)<IconProps & SpinnerIconStyleProps>`
  ${spinAnimation};

  stroke: ${({ strokeColor }) => themeGet(`colors.${strokeColor}`)};
`;

const Spinner = ({ size = 24, strokeColor, margin, className }: SpinnerProps) => (
  <Flex
    className={className}
    data-testid="spinner"
    role="progressbar"
    margin={margin}
    {...wrapperStyles}
  >
    <SpinnerIcon name="spinner" size={size} strokeColor={strokeColor} />
  </Flex>
);

const CenteredSpinner = ({ size = 24, strokeColor, margin, className }: SpinnerProps) => (
  <Flex
    className={className}
    data-testid="spinner"
    role="progressbar"
    margin={margin}
    {...wrapperStyles}
    {...fullPageWrapperStyles}
  >
    <SpinnerIcon name="spinner" size={size} strokeColor={strokeColor} />
  </Flex>
);

export { CenteredSpinner };

export default Spinner;
